"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _MultiAutoCompleteField = _interopRequireDefault(require("./MultiAutoCompleteField"));

var _helpers = require("./helpers");

var _templateObject, _templateObject2;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var createAttributeCss = function createAttributeCss(attributes, selectedAttributes) {
  var styles = '';

  for (var i = 0; i < attributes.length; i += 1) {
    styles += "\n      li[data-attribute=\"" + attributes[i].label + "\"]:before {\n        content: url(https://activitymanager" + _helpers.ENVIRONMENT + ".blob.core.windows.net/activityattributes/" + _helpers.attributeMapper[attributes[i].label] + ".svg);\n        display: inline-block;\n        height: 2em;\n        vertical-align: middle;\n        width: 2em;\n      }\n    }";
  }

  for (var _i = 0; _i < selectedAttributes.length; _i += 1) {
    styles += "\n      .ln-c-input-group__control span[class=\"ln-c-autocomplete__selected-item\"]:nth-child(" + (_i + 1) + ") {\n        &:before {\n          content: url(https://activitymanagerdev.blob.core.windows.net/activityattributes/" + _helpers.attributeMapper[selectedAttributes[_i].label] + ".svg);\n          display: inline-block;\n          height: 2em;\n          vertical-align: middle;\n          width: 2em;\n        }\n      }\n    ";
  }

  styles += "\n    .ln-c-autocomplete__selected-item {\n      max-height: 38px;\n    }\n  ";
  return (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    ", "\n  "])), styles);
};

var StyledMultiAutocompleteField = (0, _styledComponents.default)(_MultiAutoCompleteField.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (props) {
  return createAttributeCss(props.options, props.defaultSelectedOptions);
});

var AttributeSelector = function AttributeSelector(_ref) {
  var label = _ref.label,
      attributes = _ref.attributes,
      selectedAttributes = _ref.selectedAttributes,
      _onSelect = _ref.onSelect,
      error = _ref.error;

  var getFilteredAttributes = function getFilteredAttributes() {
    var selectedValues = selectedAttributes.map(function (x) {
      return x.value;
    });
    var filteredAttributes = attributes.filter(function (x) {
      return !selectedValues.includes(parseInt(x.value, 10));
    });
    return filteredAttributes;
  };

  return /*#__PURE__*/_react.default.createElement(StyledMultiAutocompleteField, {
    name: "attributes-autocomplete",
    onSelect: function onSelect(searchResults) {
      return _onSelect(searchResults);
    },
    placeholder: selectedAttributes.length > 0 ? '' : 'Enter the areas of the store that need to complete this activity',
    label: label,
    options: getFilteredAttributes(),
    defaultSelectedOptions: selectedAttributes,
    error: error
  });
};

AttributeSelector.propTypes = {
  label: _propTypes.default.string,
  attributes: _propTypes.default.array.isRequired,
  selectedAttributes: _propTypes.default.array.isRequired,
  onSelect: _propTypes.default.func.isRequired,
  error: _propTypes.default.string
};
AttributeSelector.defaultProps = {
  label: 'Which area of the store needs to do this?',
  error: ''
};
var _default = AttributeSelector;
exports.default = _default;